export default __webpack_public_path__ + "static/media/icon_simple_plin.24e37fef.svg";